/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { useAutocomplete } from '@mui/base/useAutocomplete';
import { styled } from '@mui/material/styles';

const Listbox = styled('ul')(({ theme }) => ({
  width: 185,
  margin: 0,
  padding: 0,
  zIndex: 1,
  position: 'absolute',
  listStyle: 'none',
  backgroundColor: theme.palette.background.paper,
  overflow: 'auto',
  maxHeight: 200,
  border: '1px solid rgba(0,0,0,.25)',
  '& li[data-focus="true"]': {
    backgroundColor: '#4a8df6',
    color: 'white',
    cursor: 'pointer',
  },
  '& li:active': {
    backgroundColor: '#2977f5',
    color: 'white',
  },
}));

export default function ClassAutocomplete(props) {
  const [inputValue, setInputValue] = useState('');
  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
  } = useAutocomplete({
    value: props.selectedValue,
    onChange: (event, value) => {
      props.autocompleteOnSelect(props.name, value);
    },
    inputValue: inputValue,
    onInputChange: (event, value) => {
      setInputValue(value);
    },
    id: 'use-autocomplete-demo',
    options: props.options,
    getOptionLabel: (option) => {
      return option
    }
  });

  return (
    <div>
      <div {...getRootProps()}>
        <input className="form-control" id={props.name} type="text" name={props.name} {...getInputProps()} />
      </div>
      {groupedOptions.length > 0 ? (
        <Listbox {...getListboxProps()}>
          {groupedOptions.map((option, index) => (
            <li key={index} {...getOptionProps({ option, index })}>{option}</li>
          ))}
        </Listbox>
      ) : null}
    </div>
  );
}